import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var questionDetailsRes;
export const questionDetailsTodo = createAsyncThunk('questionDetails', async (id) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'quiz/view_question_details',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "question_id": id,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return questionDetailsRes = res.data
    } catch (error) {
        return questionDetailsRes = error.response.data
    }
})


const questionDetailsSlice = createSlice({
    name: 'questionDetails',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(questionDetailsTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('questionDetails', state.data)
            }
        });
        builder.addCase(questionDetailsTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default questionDetailsSlice.reducer; 